import React, { createContext, useState } from "react";
import axios from "axios";
import Utils from "./../Utils";
import _ from "lodash";
import moment from "moment";

const UserContext = createContext();

const UserProvider = (props) => {
  const [userData, setUserData] = useState(Utils.getUserData());
  const [stepData, setUCStepData] = useState({});

  const goLogin = ({ user, pass }, callback) => {
    axios
      .post(Utils.apiUrl("admin/login"), `&username=${user}&password=${pass}`, Utils.apiHeaders())
      .then((res) => {
        callback(res.data);
        if (res.data.success) {
          setUserData(res.data.userData);
          Utils.setUserData(res.data);
        }
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const goSSO = ({ name, email, marriott_emp }, callback) => {
    const body = {
      name,
      email,
      marriott_emp,
    };

    axios
      .post(Utils.apiUrl("frontend/auth/hotelrep-sso"), body, Utils.apiHeaders())
      .then((res) => {
        callback(res.data);
        if (res.data?.success) {
          initUserData(res.data);
        }
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const initUserData = (data) => {
    console.log('Tokenized data received',{
      token: data.token,
      userData: data.userData,
    });
    Utils.setUserData({
      token: data.token,
      userData: data.userData,
    });
    setUserData(data.userData);
  }

  const phLogin = (data, callback) => {
    axios
      .post(Utils.apiUrl("frontend/auth"), data, Utils.apiHeaders())
      .then((res) => {
        console.log(res.data);
        callback(res.data);
        if (res.data.success) {
          setUserData(res.data.userData);
          Utils.setUserData(res.data);
        }
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const logout = () => {
    setUserData(false);
    Utils.setUserData(false);
  };

  const getServerData = (url, pageInfo = false) => {
    return new Promise((resolve, reject) => {
      axios
        .get(Utils.apiUrl(url), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            resolve(pageInfo ? res.data : res.data.data);
          } else {
            reject(res.data.message);
          }
        })
        .catch(reject);
    });
  };
  const setServerData = (url, data, method = "put", extraHeaders = {}) => {
    return new Promise((resolve, reject) => {
      axios[method](Utils.apiUrl(url), data, Utils.apiHeaders(extraHeaders))
        .then((res) => {
          if (res.data.success) {
            alert(res.data.id);
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        })
        .catch(reject);
    });
  };

  

  const isCertified = () => { 
    return  _.get(userData,'certificate',false) && 
            _.get(userData,'certificate.attempted',false) && 
            moment(userData.certificate.expires_by).isAfter(moment());
  };

  return (
    <UserContext.Provider
      value={{
        userData,
        goLogin,
        logout,
        getServerData,
        setServerData,
        goSSO,
        phLogin,
        initUserData,
        isCertified
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContext;

export { UserProvider };
